import type { AdjustmentValue, Adjustments, TierAdjustmentValue } from './PriceSimulation.types';
import type { PackageWorksheet } from './worksheetDataTransformer';
import { isTiered } from './priceSimulationModel';

export const seedAdjustments = (prev: Adjustments, packages: PackageWorksheet[]): Adjustments => {
    const next = { ...prev };

    packages.forEach((pkg) => {
        pkg.tiers.forEach((tier) => {
            tier.productGroups.forEach((group) => {
                group.products.forEach((product) => {
                    product.plans.forEach((plan) => {
                        const productAdj: Record<string, AdjustmentValue> | undefined = next[product.id];
                        if (productAdj?.[plan.id] !== undefined) return;

                        if (!isTiered(plan) && plan.isKept) {
                            next[product.id] = { ...next[product.id], [plan.id]: { percentage: 0, newPrice: plan.currentPrice, isKept: true } };
                            return;
                        }

                        if (isTiered(plan)) {
                            const seededTiers: Record<number, TierAdjustmentValue> = {};
                            (plan.tieredPrices ?? []).forEach((tp) => {
                                const pct = tp.adjustmentPercentage ?? 0;
                                const cur = tp.currentUnitPrice ?? 0;
                                const nu = tp.newUnitPrice ?? cur;
                                if (tp.isKept === true) {
                                    seededTiers[tp.index ?? 0] = { percentage: 0, newUnitPrice: cur, isKept: true };
                                } else if (pct !== 0 || nu !== cur) {
                                    seededTiers[tp.index ?? 0] = { percentage: pct, newUnitPrice: nu };
                                }
                            });
                            if (Object.keys(seededTiers).length > 0) {
                                next[product.id] = { ...next[product.id], [plan.id]: { percentage: 0, newPrice: 0, tiers: seededTiers } };
                            }
                            return;
                        }

                        // A 0 kr base has a 0% adjustment even when a price was saved for it, so compare the prices too.
                        if (plan.adjustmentPercentage !== 0 || plan.newPrice !== plan.currentPrice) {
                            next[product.id] = { ...next[product.id], [plan.id]: { percentage: plan.adjustmentPercentage, newPrice: plan.newPrice } };
                        }
                    });
                });
            });
        });
    });

    return next;
};
